"use strict";

import dispatcher from "./../dispatcher";
import {Collection} from "vwa/flux";
import sessionStore from "./session";

const vehicleStateStore = new Collection({keyNames: ["carrier"]});
export default vehicleStateStore;

window.vehicleStateStore = vehicleStateStore;

dispatcher.on('getVehicleStates', vehicleStates => vehicleStateStore.set(vehicleStates));

dispatcher.on('logout', () => vehicleStateStore.set(null));

dispatcher.on('newCarrierState', carrierState => {
	vehicleStateStore.update(carrierState.carrier, carrierState);
});

/*// ÁTMENETI FÜGGVÉNY AZ ÁTÁLLÁS MIATT
function flatCarrierState(carrierState) {
	
	return {
		carrier: carrierState.carrier,
		state: Object.keys(carrierState.state).map(dataTypeId => {
			const data = carrierState.state[dataTypeId];
			if (data.type == "LogicalStateChange")
				data.type = "Logical";
			return data;
		})
	};
}*/


// WEBPACK FOOTER //
// ./src/store/vehicleStates.js